module.exports = __webpack_public_path__ + "img/itss.f58ac2c2.png";